<template>
  <v-text-field
    v-model="value"
    :label="label"
    :hideDetails="hideDetails"
    :class="{ 'input-save--changed': isChanged }"
    @focus="showSave = true"
  >
    <template slot="append-outer">
      <v-icon color="info" v-if="showSave" @click.prevent.stop="save()">
        save
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
import { DOCUMENT_AVAILABLE_FIELDS } from "@/modules/documents/add-document/document-available-fields.js";
import { uniqueId } from "lodash/util";
import { DynamicFieldsManager } from "@/modules/documents/add-document/dynamic-fields.manager.js";
import asFormData from "json-form-data";
import { API_ERROR_MESSAGE } from "@/config.js";
import dayjs from "dayjs";
export default {
  name: "InputSave",

  props: {
    field: {
      type: String,
      required: true,
    },
    param: {
      type: Number,
      required: true,
    },
    measure: { type: Number, required: true },
    label: {
      type: String,
      default: "",
    },

    hideDetails: {
      type: Boolean,
      default: false,
    },

    lastValue: {
      type: [Number, String],
      default: null,
    },
  },

  data: () => ({
    showSave: false,
    value: "",
    savedValue: null,
  }),

  watch: {
    lastValue: {
      immediate: true,
      handler(val) {
        if (val !== null && val !== undefined) {
          this.value = val;
          this.savedValue = val;
        }
      },
    },
  },

  computed: {
    isChanged() {
      return this.value !== this.savedValue && this.value !== "" && this.value !== null;
    },
  },

  methods: {
    // TODO: перенести все эти методы в DynamicFieldsManager
    async save() {
      this.showSave = false;

      // Явная проверка на пустое: числовой 0 ("не курит") — валидное значение,
      // его надо сохранять. this.value из текстового поля обычно строка.
      if (this.value !== "" && this.value !== null && this.value !== undefined) {
        // параметры это ид 2
        const params_document_id = 2;
        //   alert("Сохранено!");

        const response = await this.$http.get(`v1/documents/types/${params_document_id}/fields`, { params: { lang: "ru" } });

        const formFields = [];
        if (response.data.success) {
          for (const item of response.data.data) {
            let sourceItems = [];

            if (item.type === DOCUMENT_AVAILABLE_FIELDS.source && item.behavior?.searchable === false) {
              try {
                const { data } = await this.$http.get(`v1/documents/types/${params_document_id}/fields/${item.id}`, {
                  params: { lang: "ru" },
                });
                sourceItems = Array.isArray(data.data) ? this.prepareSourceFieldItems(data.data) : [];
              } catch (e) {
                console.error("Ошибка получения значений справочника");
              }
            }

            formFields.push({ uuid: uniqueId(), ...item, items: sourceItems, addedItems: [] });
          }
        }
        const form = {
          category: 2,
          ...DynamicFieldsManager.buildForm(formFields),
          author: this.$store.state.auth.id,
        };

        form.name = this.label;
        form.real_date = dayjs().format("DD-MM-YYYY HH:mm:ss");
        form[this.field] = [
          {
            param: this.param,
            measure: this.measure,
            value: this.value,
          },
        ];

        try {
          const response2 = await this.$http.post(`v1/customers/${this.$store.state.customer.id}/documents`, asFormData(form), {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          if (response2.data.success) {
            this.savedValue = this.value;
            this.$dialog.notify.success(response2.data.message);
          } else {
            if (response2.error && response2.error.response && response2.error.response2.data) {
              this.$dialog.notify.error(response2.error.response2.data.message || "");
            }
          }
        } catch (e) {
          this.$dialog.notify.error(e.response2.message || API_ERROR_MESSAGE);
        }
      }
    },
  },
};
</script>

<style scoped>
.input-save--changed :deep(input) {
  font-weight: bold !important;
  color: #fb8c00 !important;
}
.input-save--changed :deep(.v-label) {
  font-weight: bold !important;
  color: #fb8c00 !important;
}
</style>
